import { DateTime } from "luxon"
import { TableHeaderConfigWithType } from "../../components/_EOS/Table"
import { WorkOrderRecall } from "./entities/WorkOrderRecall"
import { utcToLocal } from "../../utils/dateHelper"
import { WorkOrderState } from "../../interfaces"
import { Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material'
import React from "react"
import { eTypeStorage } from "../../enums/eTypeStorage"

export const generateTableHeadersWorkOrderRecall = (
    workOrderStates: WorkOrderState[],

) => {

    const tableHeaders: TableHeaderConfigWithType<WorkOrderRecall>[] =
      [
        {
          field: 'workOrderId',
          title: 'ID',
          sortable: true,
        },
        {
            field: 'workOrderStateId',
            title: 'Estado',
            formater: (workOrderStateId: unknown) =>
              workOrderStates?.filter(
                (el) => el.workOrderStateId === workOrderStateId as number
              )[0]?.state || 'Sin Estado'
        },
        {
          field: 'createdAt',
          title: 'Fecha de Creación',
          sortable: false,
          formater: (createdAt: unknown) => utcToLocal(createdAt as string, 'dd/MM/yyyy')
        },
        {
          field: 'promiseDate',
          title: 'Fecha Compromiso',
          sortable: false,
          formater: (promiseDate: unknown) => formatNullableDate(promiseDate)
        },
        {
          field: 'withControl',
          title: 'Con Control',
          sortable: false,
          formater:(withControl: unknown) => setIconWithControl(withControl as boolean)
        },
        {
          field: 'typeStorage',
          title: 'Tipo',
          sortable:false,
          formater: (type: unknown) => setType(type as number)
        }
        ,
        {
          field: 'workOrderTag',
          title: 'Tag',
          sortable:false,
        }
      ]
  
    return tableHeaders
}

  
  const formatNullableDate = (date: DateTime| unknown) => {
    if(date)
      return utcToLocal(date as string, 'dd/MM/yyyy')
    else
      return '' 
  }
  
const setIconWithControl = (withControl: boolean) => {

  const Icon = withControl ? CheckIcon : CloseIcon
 let backgroundColor = ''
  let colorText = ''

  if(withControl){
      backgroundColor = '#4caf50'
      colorText = 'white'
  }else{
      backgroundColor = '#f48fb1'
      colorText = 'black'
  }

  return (
    <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '2px 8px',
      borderRadius: '20px',
      backgroundColor,
      color: colorText,
      fontSize: '10px'
    }}
  >
        <Icon style={{ marginRight: '2px' }} />
      </div>
  )
}

const setType = (idType: number) => {
  return eTypeStorage[idType] || ''
}